export default "__VITE_ASSET__DXJNQvFU__"